// Default Cookies Code Star
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
// Default Cookies Code End

// CWI CODE J

if ($(".image_slider .image_list").length) {
  $(".image_slider .image_list").each(function(index, banner_slider) {
    let banner_Swiper = new Swiper(banner_slider, {
      loop: true,
      slidesPerView: 1,     
      autoHeight: true, 
      navigation: {
        nextEl: $(banner_slider).closest(".image_slider").find(".next_arrow")[0],
        prevEl: $(banner_slider).closest(".image_slider").find(".prev_arrow")[0],
      },    
      pagination: {
        el: $(banner_slider).closest(".image_slider").find(".banner_dot")[0],
        clickable: true,
      },   
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },      
    });
    // $(".image_slider").removeClass("hidden");
  });
}

if ($(".collections_list_slider .coll_list_slider").length) {
  $(".collections_list_slider .coll_list_slider").each(function(index, collections_slider) {
    let review_grid_Swiper = new Swiper(collections_slider, {
      loop: true,
      slidesPerView: 4,    
      spaceBetween: 24,
      navigation: {
        nextEl: $(collections_slider).closest(".collections_list_slider").find(".next_arrow")[0],
        prevEl: $(collections_slider).closest(".collections_list_slider").find(".prev_arrow")[0],
      }, 
      pagination: {
        el: $(collections_slider).closest(".collections_list_slider").find(".pagination_dot")[0],
        clickable: true,
      },   
      breakpoints: {
        1280: {
          slidesPerView: 4,
        },    
        990: {
          slidesPerView: 2,
        },         
        750: {
          slidesPerView: 1.5,
          spaceBetween: 24,
        },
        0: {
          slidesPerView: 1.2,
          spaceBetween: 16,
        },        
      },           
    });
    // $(".collections_list_slider").removeClass("hidden");
  });
}

if ($(".new_featured_blog .featured_blog_slider").length) {
  $(".new_featured_blog .featured_blog_slider").each(function(index, blog_slider) {
    let blog_grid_Swiper = new Swiper(blog_slider, {
      loop: true,
      slidesPerView: 1.2,    
      spaceBetween: 24,
      lazy: true,
      breakpoints: { 
        0: {
          slidesPerView: 1.2,
          spaceBetween: 16
        },
        750: {
          slidesPerView: 1.5,
          spaceBetween: 24
        },
        990: {
          slidesPerView: 2
        },
        1280: {
          slidesPerView: 3
        }
      }
    });    
  });
}

// CWI CODE N
function build_recently_viewed(handles) {
  if (handles.length) {
    var handle = handles.shift();
    var language_change = $('html').attr("lang");
    var new_lag = '';
    if (language_change != 'en') {
      new_lag = '/' + language_change;
    }

    $.ajax({
      url: new_lag + '/products/' + handle + '/?view=recently-view',
      type: 'get',
      dataType: 'html',
      success: function (response) {
        $('#recent_view_product_grid').prepend(response);
        build_recently_viewed(handles);

        if(handles.length == 0){
          // new Swiper('.recent-view .swiper', {
          //   slidesPerView: 'auto',
          //   spaceBetween: 16,
          //   loop: false,
          //   slidesOffsetBefore: 15,
          //   slidesOffsetAfter: 15,
          //   breakpoints: {
          //     750: {
          //       spaceBetween: 24,
          //       slidesOffsetBefore: 100,
          //       slidesOffsetAfter: 100,
          //     }
          //   }
          // });
          if($('.recent-view.hidden').length){
            $('.recent-view.hidden').removeClass("hidden");
          }
        }
        
      }
    });
  }
}

$(function () {
  if ($('#recent_view_product_grid').length) {
    if (getCookie('pro_recently_view') != '') {
      var handles = getCookie('pro_recently_view').split('||');
      handles.reverse();
      build_recently_viewed(handles);
    }
  }
  if ($('body').hasClass('template-product')) {
    var handles = [];
    var handle = location.pathname.split('/');
    handle = handle[handle.length - 1];
    if (getCookie('pro_recently_view') != '') handles = getCookie('pro_recently_view').split('||');
    if (handles.length > 8) handles.pop();
    handles.unshift(handle);
    handles = handles.filter(function (item, pos) {
      return handles.indexOf(item) == pos;
    })
    setCookie('pro_recently_view', handles.join('||'), 365);
  }
});

// Main product media slider
function mainProSwiper(){
  if ($('.product-main-media-data .product_media_main').length) {
    var mainProHeight = $('.product-main-media-data .product_media_main').height();

    window.proThumbSwiperInstance = null;

    if ($('.product-main-media-data .product_media_thumb').length) {
      $('.product-main-media-data .product_media_thumb').css("height",`${mainProHeight}px`)
      window.proThumbSwiperInstance = new Swiper('.product-main-media-data .product_media_thumb', {
        slidesPerView: "auto",
        spaceBetween: 10,
        loop: false,
        observer: true,
        observeParents: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        breakpoints: {
          0: {
            direction: 'horizontal'
          },
          749: {
            direction: 'vertical'
          }
        }
      });
    }

    window.proMainSwiperInstance = new Swiper('.product-main-media-data .product_media_main', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      effect: 'slide',
      observer: true,
      observeParents: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: '.product_media_main .swiper-button-next',
        prevEl: '.product_media_main .swiper-button-prev',
      },
      pagination: {
          el: '.product_media_main .swiper-dots',
          clickable: true
      },
      // thumbs: {
      //   swiper: window.proThumbSwiperInstance
      // }
    });
  }
}

mainProSwiper();

function productMediaFilterSlide(filterName,proMainSwiperSlide,proThumbSwiperSlide){
  var allSlideShow = true,
      allThumbShow = true;

  proMainSwiperSlide.forEach(function(single_slide){
    var mediaAlt = single_slide.getAttribute('mediaalt');
    if(mediaAlt == filterName){
      single_slide.style.display = 'block';
      allSlideShow = false;
    }else{
      single_slide.style.display = 'none';
    }
  });

  proThumbSwiperSlide.forEach(function(single_slide){
    var mediaAlt = single_slide.getAttribute('mediaalt');
    if(mediaAlt == filterName){
      single_slide.style.display = 'block';
      allThumbShow = false;
    }else{
      single_slide.style.display = 'none';
    }
  });

  if(allSlideShow){
    proMainSwiperSlide.forEach(function(single_slide){
      single_slide.style.display = 'block';
    });
  }

  if(allThumbShow){
    proThumbSwiperSlide.forEach(function(single_slide){
      single_slide.style.display = 'block';
    });
  }

  if(window.proMainSwiperInstance) {
    window.proMainSwiperInstance.update();
    window.proMainSwiperInstance.slideTo(0, 0);
  }  
  
  if(window.proThumbSwiperInstance) {
    window.proThumbSwiperInstance.update();
    window.proThumbSwiperInstance.slideTo(0, 0);
    
      proThumbSwiperSlide.forEach(s => s.classList.remove('swiper-slide-thumb-active'));
      var firstVisibleThumb = Array.from(proThumbSwiperSlide).find(s => s.style.display !== 'none');
      if (firstVisibleThumb) {
        firstVisibleThumb.classList.add('swiper-slide-thumb-active');
      }
  }

  proThumbSwiperSlide.forEach(function(thumb) {
    thumb.onclick = function() {
      var mediaID = this.getAttribute('data_meida_id'),
          visibleSlides = Array.from(proMainSwiperSlide).filter(s => s.style.display !== 'none'),
          targetIndex = visibleSlides.findIndex(s => s.getAttribute('data_meida_id') === mediaID);
      
      if (targetIndex !== -1 && window.proMainSwiperInstance) {
        window.proMainSwiperInstance.slideTo(targetIndex);
      }
    };
  });

  if (window.proMainSwiperInstance) {
    window.proMainSwiperInstance.on('slideChange', function() {
      var activeMainSlide = Array.from(proMainSwiperSlide).filter(s => s.style.display !== 'none')[this.activeIndex];
      if (!activeMainSlide) return;

      var mediaID = activeMainSlide.getAttribute('data_meida_id'),
          visibleThumbs = Array.from(proThumbSwiperSlide).filter(s => s.style.display !== 'none'),
          thumbIndex = visibleThumbs.findIndex(s => s.getAttribute('data_meida_id') === mediaID);

      if (thumbIndex !== -1 && window.proThumbSwiperInstance) {
        window.proThumbSwiperInstance.slideTo(thumbIndex);
        
        proThumbSwiperSlide.forEach(s => s.classList.remove('swiper-slide-thumb-active'));
        visibleThumbs[thumbIndex].classList.add('swiper-slide-thumb-active');
      }
    });
  }
}

function defaultVariantInputCheck(){
  if(document.querySelector('variant-selects .filter_color input:checked')){
    var filterName = document.querySelector('variant-selects .filter_color input:checked').value.toLowerCase().trim(),
    proMainSwiperSlide = document.querySelectorAll('.product_media_main .swiper-slide'),
    proThumbSwiperSlide = document.querySelectorAll('.product_media_thumb .swiper-slide');
    productMediaFilterSlide(filterName,proMainSwiperSlide,proThumbSwiperSlide);
  }
}

defaultVariantInputCheck();

function variant_JSON(scope_this,variant){
  var _this = scope_this;
  if(_this.querySelector('.filter_color')){
    var filterIndex = parseInt(_this.querySelector('.filter_color').getAttribute('option_index')),
        filterName = variant.options[filterIndex].toLowerCase().trim(),
        proMainSwiperSlide = _this.querySelectorAll('.product_media_main .swiper-slide'),
        proThumbSwiperSlide = _this.querySelectorAll('.product_media_thumb .swiper-slide');
    productMediaFilterSlide(filterName,proMainSwiperSlide,proThumbSwiperSlide);
  }
}

function varaint_wise_tab(){
  if(document.querySelector("variant-selects")){
    var variantTitle = document.querySelector("variant-selects").getAttribute("variantTitle");
    document.querySelectorAll(".varaint_wise_tab").forEach(function(singleTab){
      singleTab.classList.add("hidden");
      if(singleTab.hasAttribute("color_type") && singleTab.getAttribute("color_type") == variantTitle){
        singleTab.classList.remove("hidden");
      }
    });
  }else{
    document.querySelectorAll(".varaint_wise_tab").forEach(function(singleTab){
      singleTab.classList.remove("hidden");
    });
  }
}

varaint_wise_tab();

function loadmoreinfinity() {
  var isLoading = false;

  // Create the loader element once and insert it after the product grid
  var infinityLoader = document.getElementById("infinity-scroll-loader");
  if (!infinityLoader) {
    infinityLoader = document.createElement("div");
    infinityLoader.id = "infinity-scroll-loader";
    infinityLoader.innerHTML = '<div class="infinity-spinner"></div><p class="infinity-loader-text">Loading more products<span class="infinity-dot">.</span><span class="infinity-dot">.</span><span class="infinity-dot">.</span></p>';

    var productGrid = document.getElementById("product-grid");
    if (productGrid && productGrid.parentNode) {
      productGrid.parentNode.insertAdjacentElement("afterend", infinityLoader);
    }
  }

  function showLoader() {
    if (infinityLoader) infinityLoader.classList.add("is-visible");
  }

  function hideLoader() {
    if (infinityLoader) infinityLoader.classList.remove("is-visible");
  }

  function scrollHandler() {
    var infinityScroll = document.querySelector(".infinity_scroll");
    if (!infinityScroll || isLoading) return;

    var scrollTop = document.documentElement.scrollTop,
        triggerPoint = infinityScroll.offsetTop - window.innerHeight;

    if (scrollTop >= triggerPoint) {
      isLoading = true;
      showLoader();

      var currentPage = parseInt(infinityScroll.dataset.currentPage),
          totalPages = parseInt(infinityScroll.dataset.totalPages),
          nextUrl = infinityScroll.dataset.nextUrl;

      if (!nextUrl) {
        hideLoader();
        return;
      }

      fetch(nextUrl)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");

          var newProducts = doc.querySelector("#product-grid").innerHTML;
          document
            .querySelector("#product-grid")
            .insertAdjacentHTML("beforeend", newProducts);

          var newInfinity = doc.querySelector(".infinity_scroll");

          if (newInfinity) {
            infinityScroll.dataset.currentPage = newInfinity.dataset.currentPage;
            infinityScroll.dataset.nextUrl = newInfinity.dataset.nextUrl;
          }

          currentPage = parseInt(infinityScroll.dataset.currentPage);

          hideLoader();

          if (currentPage >= totalPages) {
            window.removeEventListener("scroll", scrollHandler);
            infinityScroll.remove();
            if (infinityLoader) infinityLoader.remove();
          }

          isLoading = false;
        })
        .catch(function () {
          hideLoader();
          isLoading = false;
        });
    }
  }

  window.addEventListener("scroll", scrollHandler);
}

loadmoreinfinity();


// Gift Wrap — auto-sync gift product quantity with cart
function updateOrGetCart(){
  if(document.querySelector("body[giftproduct]")){
    fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET'
    })
    .then(response => {
      return response.json();
    })
    .then(cart => {
      var itemQuantity = 0;

      cart.items.forEach(function(item){
        var gift_properties = item.properties["Gift wrap"];
        if(gift_properties){
          itemQuantity += item.quantity;
        }
      });

      if(itemQuantity >= 0){
        var product_var_ID = parseInt(document.querySelector("body[giftproduct]").getAttribute("giftproduct"));
        cart_add_product(product_var_ID,itemQuantity);
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

function cart_add_product(product_var_ID, product_QTY) {
  let updates = {};
  updates[product_var_ID] = product_QTY;

  const cartDrawer = document.querySelector('cart-drawer');
  const config = fetchConfig('javascript');
  config.method = 'POST';
  config.headers['Content-Type'] = 'application/json';
  config.body = JSON.stringify({
    updates,
    sections: cartDrawer ? cartDrawer.getSectionsToRender().map(section => section.id) : [],
    sections_url: window.location.pathname
  });

  fetch(`${routes.cart_update_url}`, config)
    .then(response => response.json())
    .then(response => {
      if (cartDrawer) {
        CartPerformance.measure("update:paint-updated-sections", () => {
          cartDrawer.renderContents(response);
        });
      }

      if (response.item_count === 0 && cartDrawer) {
        cartDrawer.classList.add('is-empty');
      } else if (cartDrawer) {
        cartDrawer.classList.remove('is-empty');
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll("form .checkout_JS").forEach(function(checkout_BTN) {
    checkout_BTN.addEventListener("click", function(event) {
      event.preventDefault();
      var form = checkout_BTN.closest("form");
      if (!form) return;

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        var giftCheckbox = checkout_BTN.closest("product-info").querySelector(".product-gift-wrap");
        if (giftCheckbox && giftCheckbox.checked) {
          var gift_product_var_ID = parseInt(
            document.querySelector("body[giftproduct]").getAttribute("giftproduct")
          );
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [
                {
                  id: gift_product_var_ID,
                  quantity: 1
                }
              ]
            })
          }).then(res => res.json());
        }
      })
      .then(giftData => {
        window.location.href = '/checkout';
      })
      .catch(error => {
        console.error("Error:", error);
      });
    });
  });
});

// CWI CODE J

var btn = $('#button');
$(window).scroll(function () {
  if ($(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function (e) {
  e.preventDefault();
  $('html, body').animate({ scrollTop: 0 }, 1000);
});

if ($(".highlight-image-section .swiper-highlight-image").length) {
  $(".highlight-image-section .swiper-highlight-image").each(function(index, highlight_image) {
    let highlight_image_Swiper = new Swiper(highlight_image, {
      effect: "coverflow",
      centeredSlides: true,
      speed: 600,
      // loopAdditionalSlides: 4,
      // loopedSlides: 6,
      loop: true,
      slidesPerView: "3",
      coverflowEffect: {
        rotate: 9,
        stretch: 0,
        depth: 200,
        modifier: 1,
        slideShadows: false
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },      
      // initialSlide: 1,
      navigation: {
        nextEl: $(highlight_image).closest(".highlight-image-section").find(".next_arrow")[0],
        prevEl: $(highlight_image).closest(".highlight-image-section").find(".prev_arrow")[0],
      },       
      breakpoints: {
        0: {
          slidesPerView: 2
        },
        750: {
          slidesPerView: 2
        },
        990: {
          slidesPerView: 3
        }
      }          
    });    
    // $(".highlight-image-section").removeClass("hidden");    
  });
}